// Join multiple HTML element text together so it's read as one sentence by screen readers.
export const joinInnerTextForScreenReader = (element: HTMLElement | null, join = ' ') => {
  const elementHTML = element?.innerHTML || '';
  const divElement = document.createElement('div');

  const getText = (element: Node) => {
    const textNodes: string[] = [];

    const getTextNodes = (node: Node) => {
      node.childNodes.forEach(childNode => {
        if (childNode.nodeType === Node.TEXT_NODE && childNode.textContent && childNode.textContent !== ' ') {
          textNodes.push(childNode.textContent.trim());
        } else {
          getTextNodes(childNode);
        }
      });
    };

    getTextNodes(element);

    return textNodes.join(join);
  };

  divElement.innerHTML = elementHTML;

  divElement.querySelectorAll('[aria-hidden="true"]').forEach(element => {
    element.remove();
  });

  return getText(divElement);
};
